import { ENV } from '@environment';
import { countries } from 'api';

import { RestCountryResponse } from 'models/restCountry';

const fallbackResponse: RestCountryResponse[] = [
    {
        'name': 'Afghanistan',
        'alpha2Code': 'AF',
        'callingCodes': [
            '93'
        ],
        'flag': 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg',
        'independent': false
    },
    {
        'name': 'Åland Islands',
        'alpha2Code': 'AX',
        'callingCodes': [
            '358'
        ],
        'flag': 'https://flagcdn.com/ax.svg',
        'independent': false
    },
    {
        'name': 'Albania',
        'alpha2Code': 'AL',
        'callingCodes': [
            '355'
        ],
        'flag': 'https://flagcdn.com/al.svg',
        'independent': false
    },
    {
        'name': 'Algeria',
        'alpha2Code': 'DZ',
        'callingCodes': [
            '213'
        ],
        'flag': 'https://flagcdn.com/dz.svg',
        'independent': false
    },
    {
        'name': 'American Samoa',
        'alpha2Code': 'AS',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/as.svg',
        'independent': false
    },
    {
        'name': 'Andorra',
        'alpha2Code': 'AD',
        'callingCodes': [
            '376'
        ],
        'flag': 'https://flagcdn.com/ad.svg',
        'independent': false
    },
    {
        'name': 'Angola',
        'alpha2Code': 'AO',
        'callingCodes': [
            '244'
        ],
        'flag': 'https://flagcdn.com/ao.svg',
        'independent': false
    },
    {
        'name': 'Anguilla',
        'alpha2Code': 'AI',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/ai.svg',
        'independent': false
    },
    {
        'name': 'Antarctica',
        'alpha2Code': 'AQ',
        'callingCodes': [
            '672'
        ],
        'flag': 'https://flagcdn.com/aq.svg',
        'independent': false
    },
    {
        'name': 'Antigua and Barbuda',
        'alpha2Code': 'AG',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/ag.svg',
        'independent': false
    },
    {
        'name': 'Argentina',
        'alpha2Code': 'AR',
        'callingCodes': [
            '54'
        ],
        'flag': 'https://flagcdn.com/ar.svg',
        'independent': false
    },
    {
        'name': 'Armenia',
        'alpha2Code': 'AM',
        'callingCodes': [
            '374'
        ],
        'flag': 'https://flagcdn.com/am.svg',
        'independent': false
    },
    {
        'name': 'Aruba',
        'alpha2Code': 'AW',
        'callingCodes': [
            '297'
        ],
        'flag': 'https://flagcdn.com/aw.svg',
        'independent': false
    },
    {
        'name': 'Australia',
        'alpha2Code': 'AU',
        'callingCodes': [
            '61'
        ],
        'flag': 'https://flagcdn.com/au.svg',
        'independent': false
    },
    {
        'name': 'Austria',
        'alpha2Code': 'AT',
        'callingCodes': [
            '43'
        ],
        'flag': 'https://flagcdn.com/at.svg',
        'independent': false
    },
    {
        'name': 'Azerbaijan',
        'alpha2Code': 'AZ',
        'callingCodes': [
            '994'
        ],
        'flag': 'https://flagcdn.com/az.svg',
        'independent': false
    },
    {
        'name': 'Bahamas',
        'alpha2Code': 'BS',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/bs.svg',
        'independent': false
    },
    {
        'name': 'Bahrain',
        'alpha2Code': 'BH',
        'callingCodes': [
            '973'
        ],
        'flag': 'https://flagcdn.com/bh.svg',
        'independent': false
    },
    {
        'name': 'Bangladesh',
        'alpha2Code': 'BD',
        'callingCodes': [
            '880'
        ],
        'flag': 'https://flagcdn.com/bd.svg',
        'independent': false
    },
    {
        'name': 'Barbados',
        'alpha2Code': 'BB',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/bb.svg',
        'independent': false
    },
    {
        'name': 'Belarus',
        'alpha2Code': 'BY',
        'callingCodes': [
            '375'
        ],
        'flag': 'https://flagcdn.com/by.svg',
        'independent': false
    },
    {
        'name': 'Belgium',
        'alpha2Code': 'BE',
        'callingCodes': [
            '32'
        ],
        'flag': 'https://flagcdn.com/be.svg',
        'independent': false
    },
    {
        'name': 'Belize',
        'alpha2Code': 'BZ',
        'callingCodes': [
            '501'
        ],
        'flag': 'https://flagcdn.com/bz.svg',
        'independent': false
    },
    {
        'name': 'Benin',
        'alpha2Code': 'BJ',
        'callingCodes': [
            '229'
        ],
        'flag': 'https://flagcdn.com/bj.svg',
        'independent': false
    },
    {
        'name': 'Bermuda',
        'alpha2Code': 'BM',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/bm.svg',
        'independent': false
    },
    {
        'name': 'Bhutan',
        'alpha2Code': 'BT',
        'callingCodes': [
            '975'
        ],
        'flag': 'https://flagcdn.com/bt.svg',
        'independent': false
    },
    {
        'name': 'Bolivia (Plurinational State of)',
        'alpha2Code': 'BO',
        'callingCodes': [
            '591'
        ],
        'flag': 'https://flagcdn.com/bo.svg',
        'independent': false
    },
    {
        'name': 'Bonaire, Sint Eustatius and Saba',
        'alpha2Code': 'BQ',
        'callingCodes': [
            '599'
        ],
        'flag': 'https://flagcdn.com/bq.svg',
        'independent': false
    },
    {
        'name': 'Bosnia and Herzegovina',
        'alpha2Code': 'BA',
        'callingCodes': [
            '387'
        ],
        'flag': 'https://flagcdn.com/ba.svg',
        'independent': false
    },
    {
        'name': 'Botswana',
        'alpha2Code': 'BW',
        'callingCodes': [
            '267'
        ],
        'flag': 'https://flagcdn.com/bw.svg',
        'independent': false
    },
    {
        'name': 'Bouvet Island',
        'alpha2Code': 'BV',
        'callingCodes': [
            '47'
        ],
        'flag': 'https://flagcdn.com/bv.svg',
        'independent': false
    },
    {
        'name': 'Brazil',
        'alpha2Code': 'BR',
        'callingCodes': [
            '55'
        ],
        'flag': 'https://flagcdn.com/br.svg',
        'independent': false
    },
    {
        'name': 'British Indian Ocean Territory',
        'alpha2Code': 'IO',
        'callingCodes': [
            '246'
        ],
        'flag': 'https://flagcdn.com/io.svg',
        'independent': false
    },
    {
        'name': 'United States Minor Outlying Islands',
        'alpha2Code': 'UM',
        'callingCodes': [
            '246'
        ],
        'flag': 'https://flagcdn.com/um.svg',
        'independent': false
    },
    {
        'name': 'Virgin Islands (British)',
        'alpha2Code': 'VG',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/vg.svg',
        'independent': false
    },
    {
        'name': 'Virgin Islands (U.S.)',
        'alpha2Code': 'VI',
        'callingCodes': [
            '1 340'
        ],
        'flag': 'https://flagcdn.com/vi.svg',
        'independent': false
    },
    {
        'name': 'Brunei Darussalam',
        'alpha2Code': 'BN',
        'callingCodes': [
            '673'
        ],
        'flag': 'https://flagcdn.com/bn.svg',
        'independent': false
    },
    {
        'name': 'Bulgaria',
        'alpha2Code': 'BG',
        'callingCodes': [
            '359'
        ],
        'flag': 'https://flagcdn.com/bg.svg',
        'independent': false
    },
    {
        'name': 'Burkina Faso',
        'alpha2Code': 'BF',
        'callingCodes': [
            '226'
        ],
        'flag': 'https://flagcdn.com/bf.svg',
        'independent': false
    },
    {
        'name': 'Burundi',
        'alpha2Code': 'BI',
        'callingCodes': [
            '257'
        ],
        'flag': 'https://flagcdn.com/bi.svg',
        'independent': false
    },
    {
        'name': 'Cambodia',
        'alpha2Code': 'KH',
        'callingCodes': [
            '855'
        ],
        'flag': 'https://flagcdn.com/kh.svg',
        'independent': false
    },
    {
        'name': 'Cameroon',
        'alpha2Code': 'CM',
        'callingCodes': [
            '237'
        ],
        'flag': 'https://flagcdn.com/cm.svg',
        'independent': false
    },
    {
        'name': 'Canada',
        'alpha2Code': 'CA',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/ca.svg',
        'independent': false
    },
    {
        'name': 'Cabo Verde',
        'alpha2Code': 'CV',
        'callingCodes': [
            '238'
        ],
        'flag': 'https://flagcdn.com/cv.svg',
        'independent': false
    },
    {
        'name': 'Cayman Islands',
        'alpha2Code': 'KY',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/ky.svg',
        'independent': false
    },
    {
        'name': 'Central African Republic',
        'alpha2Code': 'CF',
        'callingCodes': [
            '236'
        ],
        'flag': 'https://flagcdn.com/cf.svg',
        'independent': false
    },
    {
        'name': 'Chad',
        'alpha2Code': 'TD',
        'callingCodes': [
            '235'
        ],
        'flag': 'https://flagcdn.com/td.svg',
        'independent': false
    },
    {
        'name': 'Chile',
        'alpha2Code': 'CL',
        'callingCodes': [
            '56'
        ],
        'flag': 'https://flagcdn.com/cl.svg',
        'independent': false
    },
    {
        'name': 'China',
        'alpha2Code': 'CN',
        'callingCodes': [
            '86'
        ],
        'flag': 'https://flagcdn.com/cn.svg',
        'independent': false
    },
    {
        'name': 'Christmas Island',
        'alpha2Code': 'CX',
        'callingCodes': [
            '61'
        ],
        'flag': 'https://flagcdn.com/cx.svg',
        'independent': false
    },
    {
        'name': 'Cocos (Keeling) Islands',
        'alpha2Code': 'CC',
        'callingCodes': [
            '61'
        ],
        'flag': 'https://flagcdn.com/cc.svg',
        'independent': false
    },
    {
        'name': 'Colombia',
        'alpha2Code': 'CO',
        'callingCodes': [
            '57'
        ],
        'flag': 'https://flagcdn.com/co.svg',
        'independent': false
    },
    {
        'name': 'Comoros',
        'alpha2Code': 'KM',
        'callingCodes': [
            '269'
        ],
        'flag': 'https://flagcdn.com/km.svg',
        'independent': false
    },
    {
        'name': 'Congo',
        'alpha2Code': 'CG',
        'callingCodes': [
            '242'
        ],
        'flag': 'https://flagcdn.com/cg.svg',
        'independent': false
    },
    {
        'name': 'Congo (Democratic Republic of the)',
        'alpha2Code': 'CD',
        'callingCodes': [
            '243'
        ],
        'flag': 'https://flagcdn.com/cd.svg',
        'independent': false
    },
    {
        'name': 'Cook Islands',
        'alpha2Code': 'CK',
        'callingCodes': [
            '682'
        ],
        'flag': 'https://flagcdn.com/ck.svg',
        'independent': false
    },
    {
        'name': 'Costa Rica',
        'alpha2Code': 'CR',
        'callingCodes': [
            '506'
        ],
        'flag': 'https://flagcdn.com/cr.svg',
        'independent': false
    },
    {
        'name': 'Croatia',
        'alpha2Code': 'HR',
        'callingCodes': [
            '385'
        ],
        'flag': 'https://flagcdn.com/hr.svg',
        'independent': false
    },
    {
        'name': 'Cuba',
        'alpha2Code': 'CU',
        'callingCodes': [
            '53'
        ],
        'flag': 'https://flagcdn.com/cu.svg',
        'independent': false
    },
    {
        'name': 'Curaçao',
        'alpha2Code': 'CW',
        'callingCodes': [
            '599'
        ],
        'flag': 'https://flagcdn.com/cw.svg',
        'independent': false
    },
    {
        'name': 'Cyprus',
        'alpha2Code': 'CY',
        'callingCodes': [
            '357'
        ],
        'flag': 'https://flagcdn.com/cy.svg',
        'independent': false
    },
    {
        'name': 'Czech Republic',
        'alpha2Code': 'CZ',
        'callingCodes': [
            '420'
        ],
        'flag': 'https://flagcdn.com/cz.svg',
        'independent': false
    },
    {
        'name': 'Denmark',
        'alpha2Code': 'DK',
        'callingCodes': [
            '45'
        ],
        'flag': 'https://flagcdn.com/dk.svg',
        'independent': false
    },
    {
        'name': 'Djibouti',
        'alpha2Code': 'DJ',
        'callingCodes': [
            '253'
        ],
        'flag': 'https://flagcdn.com/dj.svg',
        'independent': false
    },
    {
        'name': 'Dominica',
        'alpha2Code': 'DM',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/dm.svg',
        'independent': false
    },
    {
        'name': 'Dominican Republic',
        'alpha2Code': 'DO',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/do.svg',
        'independent': false
    },
    {
        'name': 'Ecuador',
        'alpha2Code': 'EC',
        'callingCodes': [
            '593'
        ],
        'flag': 'https://flagcdn.com/ec.svg',
        'independent': false
    },
    {
        'name': 'Egypt',
        'alpha2Code': 'EG',
        'callingCodes': [
            '20'
        ],
        'flag': 'https://flagcdn.com/eg.svg',
        'independent': false
    },
    {
        'name': 'El Salvador',
        'alpha2Code': 'SV',
        'callingCodes': [
            '503'
        ],
        'flag': 'https://flagcdn.com/sv.svg',
        'independent': false
    },
    {
        'name': 'Equatorial Guinea',
        'alpha2Code': 'GQ',
        'callingCodes': [
            '240'
        ],
        'flag': 'https://flagcdn.com/gq.svg',
        'independent': false
    },
    {
        'name': 'Eritrea',
        'alpha2Code': 'ER',
        'callingCodes': [
            '291'
        ],
        'flag': 'https://flagcdn.com/er.svg',
        'independent': false
    },
    {
        'name': 'Estonia',
        'alpha2Code': 'EE',
        'callingCodes': [
            '372'
        ],
        'flag': 'https://flagcdn.com/ee.svg',
        'independent': false
    },
    {
        'name': 'Ethiopia',
        'alpha2Code': 'ET',
        'callingCodes': [
            '251'
        ],
        'flag': 'https://flagcdn.com/et.svg',
        'independent': false
    },
    {
        'name': 'Falkland Islands (Malvinas)',
        'alpha2Code': 'FK',
        'callingCodes': [
            '500'
        ],
        'flag': 'https://flagcdn.com/fk.svg',
        'independent': false
    },
    {
        'name': 'Faroe Islands',
        'alpha2Code': 'FO',
        'callingCodes': [
            '298'
        ],
        'flag': 'https://flagcdn.com/fo.svg',
        'independent': false
    },
    {
        'name': 'Fiji',
        'alpha2Code': 'FJ',
        'callingCodes': [
            '679'
        ],
        'flag': 'https://flagcdn.com/fj.svg',
        'independent': false
    },
    {
        'name': 'Finland',
        'alpha2Code': 'FI',
        'callingCodes': [
            '358'
        ],
        'flag': 'https://flagcdn.com/fi.svg',
        'independent': false
    },
    {
        'name': 'France',
        'alpha2Code': 'FR',
        'callingCodes': [
            '33'
        ],
        'flag': 'https://flagcdn.com/fr.svg',
        'independent': false
    },
    {
        'name': 'French Guiana',
        'alpha2Code': 'GF',
        'callingCodes': [
            '594'
        ],
        'flag': 'https://flagcdn.com/gf.svg',
        'independent': false
    },
    {
        'name': 'French Polynesia',
        'alpha2Code': 'PF',
        'callingCodes': [
            '689'
        ],
        'flag': 'https://flagcdn.com/pf.svg',
        'independent': false
    },
    {
        'name': 'French Southern Territories',
        'alpha2Code': 'TF',
        'callingCodes': [
            '262'
        ],
        'flag': 'https://flagcdn.com/tf.svg',
        'independent': false
    },
    {
        'name': 'Gabon',
        'alpha2Code': 'GA',
        'callingCodes': [
            '241'
        ],
        'flag': 'https://flagcdn.com/ga.svg',
        'independent': false
    },
    {
        'name': 'Gambia',
        'alpha2Code': 'GM',
        'callingCodes': [
            '220'
        ],
        'flag': 'https://flagcdn.com/gm.svg',
        'independent': false
    },
    {
        'name': 'Georgia',
        'alpha2Code': 'GE',
        'callingCodes': [
            '995'
        ],
        'flag': 'https://flagcdn.com/ge.svg',
        'independent': false
    },
    {
        'name': 'Germany',
        'alpha2Code': 'DE',
        'callingCodes': [
            '49'
        ],
        'flag': 'https://flagcdn.com/de.svg',
        'independent': false
    },
    {
        'name': 'Ghana',
        'alpha2Code': 'GH',
        'callingCodes': [
            '233'
        ],
        'flag': 'https://flagcdn.com/gh.svg',
        'independent': false
    },
    {
        'name': 'Gibraltar',
        'alpha2Code': 'GI',
        'callingCodes': [
            '350'
        ],
        'flag': 'https://flagcdn.com/gi.svg',
        'independent': false
    },
    {
        'name': 'Greece',
        'alpha2Code': 'GR',
        'callingCodes': [
            '30'
        ],
        'flag': 'https://flagcdn.com/gr.svg',
        'independent': false
    },
    {
        'name': 'Greenland',
        'alpha2Code': 'GL',
        'callingCodes': [
            '299'
        ],
        'flag': 'https://flagcdn.com/gl.svg',
        'independent': false
    },
    {
        'name': 'Grenada',
        'alpha2Code': 'GD',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/gd.svg',
        'independent': false
    },
    {
        'name': 'Guadeloupe',
        'alpha2Code': 'GP',
        'callingCodes': [
            '590'
        ],
        'flag': 'https://flagcdn.com/gp.svg',
        'independent': false
    },
    {
        'name': 'Guam',
        'alpha2Code': 'GU',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/gu.svg',
        'independent': false
    },
    {
        'name': 'Guatemala',
        'alpha2Code': 'GT',
        'callingCodes': [
            '502'
        ],
        'flag': 'https://flagcdn.com/gt.svg',
        'independent': false
    },
    {
        'name': 'Guernsey',
        'alpha2Code': 'GG',
        'callingCodes': [
            '44'
        ],
        'flag': 'https://flagcdn.com/gg.svg',
        'independent': false
    },
    {
        'name': 'Guinea',
        'alpha2Code': 'GN',
        'callingCodes': [
            '224'
        ],
        'flag': 'https://flagcdn.com/gn.svg',
        'independent': false
    },
    {
        'name': 'Guinea-Bissau',
        'alpha2Code': 'GW',
        'callingCodes': [
            '245'
        ],
        'flag': 'https://flagcdn.com/gw.svg',
        'independent': false
    },
    {
        'name': 'Guyana',
        'alpha2Code': 'GY',
        'callingCodes': [
            '592'
        ],
        'flag': 'https://flagcdn.com/gy.svg',
        'independent': false
    },
    {
        'name': 'Haiti',
        'alpha2Code': 'HT',
        'callingCodes': [
            '509'
        ],
        'flag': 'https://flagcdn.com/ht.svg',
        'independent': false
    },
    {
        'name': 'Heard Island and McDonald Islands',
        'alpha2Code': 'HM',
        'callingCodes': [
            '672'
        ],
        'flag': 'https://flagcdn.com/hm.svg',
        'independent': false
    },
    {
        'name': 'Vatican City',
        'alpha2Code': 'VA',
        'callingCodes': [
            '379'
        ],
        'flag': 'https://flagcdn.com/va.svg',
        'independent': false
    },
    {
        'name': 'Honduras',
        'alpha2Code': 'HN',
        'callingCodes': [
            '504'
        ],
        'flag': 'https://flagcdn.com/hn.svg',
        'independent': false
    },
    {
        'name': 'Hungary',
        'alpha2Code': 'HU',
        'callingCodes': [
            '36'
        ],
        'flag': 'https://flagcdn.com/hu.svg',
        'independent': false
    },
    {
        'name': 'Hong Kong',
        'alpha2Code': 'HK',
        'callingCodes': [
            '852'
        ],
        'flag': 'https://flagcdn.com/hk.svg',
        'independent': false
    },
    {
        'name': 'Iceland',
        'alpha2Code': 'IS',
        'callingCodes': [
            '354'
        ],
        'flag': 'https://flagcdn.com/is.svg',
        'independent': false
    },
    {
        'name': 'India',
        'alpha2Code': 'IN',
        'callingCodes': [
            '91'
        ],
        'flag': 'https://flagcdn.com/in.svg',
        'independent': false
    },
    {
        'name': 'Indonesia',
        'alpha2Code': 'ID',
        'callingCodes': [
            '62'
        ],
        'flag': 'https://flagcdn.com/id.svg',
        'independent': false
    },
    {
        'name': 'Ivory Coast',
        'alpha2Code': 'CI',
        'callingCodes': [
            '225'
        ],
        'flag': 'https://flagcdn.com/ci.svg',
        'independent': false
    },
    {
        'name': 'Iran (Islamic Republic of)',
        'alpha2Code': 'IR',
        'callingCodes': [
            '98'
        ],
        'flag': 'https://flagcdn.com/ir.svg',
        'independent': false
    },
    {
        'name': 'Iraq',
        'alpha2Code': 'IQ',
        'callingCodes': [
            '964'
        ],
        'flag': 'https://flagcdn.com/iq.svg',
        'independent': false
    },
    {
        'name': 'Ireland',
        'alpha2Code': 'IE',
        'callingCodes': [
            '353'
        ],
        'flag': 'https://flagcdn.com/ie.svg',
        'independent': false
    },
    {
        'name': 'Isle of Man',
        'alpha2Code': 'IM',
        'callingCodes': [
            '44'
        ],
        'flag': 'https://flagcdn.com/im.svg',
        'independent': false
    },
    {
        'name': 'Israel',
        'alpha2Code': 'IL',
        'callingCodes': [
            '972'
        ],
        'flag': 'https://flagcdn.com/il.svg',
        'independent': false
    },
    {
        'name': 'Italy',
        'alpha2Code': 'IT',
        'callingCodes': [
            '39'
        ],
        'flag': 'https://flagcdn.com/it.svg',
        'independent': false
    },
    {
        'name': 'Jamaica',
        'alpha2Code': 'JM',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/jm.svg',
        'independent': false
    },
    {
        'name': 'Japan',
        'alpha2Code': 'JP',
        'callingCodes': [
            '81'
        ],
        'flag': 'https://flagcdn.com/jp.svg',
        'independent': false
    },
    {
        'name': 'Jersey',
        'alpha2Code': 'JE',
        'callingCodes': [
            '44'
        ],
        'flag': 'https://flagcdn.com/je.svg',
        'independent': false
    },
    {
        'name': 'Jordan',
        'alpha2Code': 'JO',
        'callingCodes': [
            '962'
        ],
        'flag': 'https://flagcdn.com/jo.svg',
        'independent': false
    },
    {
        'name': 'Kazakhstan',
        'alpha2Code': 'KZ',
        'callingCodes': [
            '76',
            '77'
        ],
        'flag': 'https://flagcdn.com/kz.svg',
        'independent': false
    },
    {
        'name': 'Kenya',
        'alpha2Code': 'KE',
        'callingCodes': [
            '254'
        ],
        'flag': 'https://flagcdn.com/ke.svg',
        'independent': false
    },
    {
        'name': 'Kiribati',
        'alpha2Code': 'KI',
        'callingCodes': [
            '686'
        ],
        'flag': 'https://flagcdn.com/ki.svg',
        'independent': false
    },
    {
        'name': 'Kuwait',
        'alpha2Code': 'KW',
        'callingCodes': [
            '965'
        ],
        'flag': 'https://flagcdn.com/kw.svg',
        'independent': false
    },
    {
        'name': 'Kyrgyzstan',
        'alpha2Code': 'KG',
        'callingCodes': [
            '996'
        ],
        'flag': 'https://flagcdn.com/kg.svg',
        'independent': false
    },
    {
        'name': 'Lao People\'s Democratic Republic',
        'alpha2Code': 'LA',
        'callingCodes': [
            '856'
        ],
        'flag': 'https://flagcdn.com/la.svg',
        'independent': false
    },
    {
        'name': 'Latvia',
        'alpha2Code': 'LV',
        'callingCodes': [
            '371'
        ],
        'flag': 'https://flagcdn.com/lv.svg',
        'independent': false
    },
    {
        'name': 'Lebanon',
        'alpha2Code': 'LB',
        'callingCodes': [
            '961'
        ],
        'flag': 'https://flagcdn.com/lb.svg',
        'independent': false
    },
    {
        'name': 'Lesotho',
        'alpha2Code': 'LS',
        'callingCodes': [
            '266'
        ],
        'flag': 'https://flagcdn.com/ls.svg',
        'independent': false
    },
    {
        'name': 'Liberia',
        'alpha2Code': 'LR',
        'callingCodes': [
            '231'
        ],
        'flag': 'https://flagcdn.com/lr.svg',
        'independent': false
    },
    {
        'name': 'Libya',
        'alpha2Code': 'LY',
        'callingCodes': [
            '218'
        ],
        'flag': 'https://flagcdn.com/ly.svg',
        'independent': false
    },
    {
        'name': 'Liechtenstein',
        'alpha2Code': 'LI',
        'callingCodes': [
            '423'
        ],
        'flag': 'https://flagcdn.com/li.svg',
        'independent': false
    },
    {
        'name': 'Lithuania',
        'alpha2Code': 'LT',
        'callingCodes': [
            '370'
        ],
        'flag': 'https://flagcdn.com/lt.svg',
        'independent': false
    },
    {
        'name': 'Luxembourg',
        'alpha2Code': 'LU',
        'callingCodes': [
            '352'
        ],
        'flag': 'https://flagcdn.com/lu.svg',
        'independent': false
    },
    {
        'name': 'Macao',
        'alpha2Code': 'MO',
        'callingCodes': [
            '853'
        ],
        'flag': 'https://flagcdn.com/mo.svg',
        'independent': false
    },
    {
        'name': 'North Macedonia',
        'alpha2Code': 'MK',
        'callingCodes': [
            '389'
        ],
        'flag': 'https://flagcdn.com/mk.svg',
        'independent': false
    },
    {
        'name': 'Madagascar',
        'alpha2Code': 'MG',
        'callingCodes': [
            '261'
        ],
        'flag': 'https://flagcdn.com/mg.svg',
        'independent': false
    },
    {
        'name': 'Malawi',
        'alpha2Code': 'MW',
        'callingCodes': [
            '265'
        ],
        'flag': 'https://flagcdn.com/mw.svg',
        'independent': false
    },
    {
        'name': 'Malaysia',
        'alpha2Code': 'MY',
        'callingCodes': [
            '60'
        ],
        'flag': 'https://flagcdn.com/my.svg',
        'independent': false
    },
    {
        'name': 'Maldives',
        'alpha2Code': 'MV',
        'callingCodes': [
            '960'
        ],
        'flag': 'https://flagcdn.com/mv.svg',
        'independent': false
    },
    {
        'name': 'Mali',
        'alpha2Code': 'ML',
        'callingCodes': [
            '223'
        ],
        'flag': 'https://flagcdn.com/ml.svg',
        'independent': false
    },
    {
        'name': 'Malta',
        'alpha2Code': 'MT',
        'callingCodes': [
            '356'
        ],
        'flag': 'https://flagcdn.com/mt.svg',
        'independent': false
    },
    {
        'name': 'Marshall Islands',
        'alpha2Code': 'MH',
        'callingCodes': [
            '692'
        ],
        'flag': 'https://flagcdn.com/mh.svg',
        'independent': false
    },
    {
        'name': 'Martinique',
        'alpha2Code': 'MQ',
        'callingCodes': [
            '596'
        ],
        'flag': 'https://flagcdn.com/mq.svg',
        'independent': false
    },
    {
        'name': 'Mauritania',
        'alpha2Code': 'MR',
        'callingCodes': [
            '222'
        ],
        'flag': 'https://flagcdn.com/mr.svg',
        'independent': false
    },
    {
        'name': 'Mauritius',
        'alpha2Code': 'MU',
        'callingCodes': [
            '230'
        ],
        'flag': 'https://flagcdn.com/mu.svg',
        'independent': false
    },
    {
        'name': 'Mayotte',
        'alpha2Code': 'YT',
        'callingCodes': [
            '262'
        ],
        'flag': 'https://flagcdn.com/yt.svg',
        'independent': false
    },
    {
        'name': 'Mexico',
        'alpha2Code': 'MX',
        'callingCodes': [
            '52'
        ],
        'flag': 'https://flagcdn.com/mx.svg',
        'independent': false
    },
    {
        'name': 'Micronesia (Federated States of)',
        'alpha2Code': 'FM',
        'callingCodes': [
            '691'
        ],
        'flag': 'https://flagcdn.com/fm.svg',
        'independent': false
    },
    {
        'name': 'Moldova (Republic of)',
        'alpha2Code': 'MD',
        'callingCodes': [
            '373'
        ],
        'flag': 'https://flagcdn.com/md.svg',
        'independent': false
    },
    {
        'name': 'Monaco',
        'alpha2Code': 'MC',
        'callingCodes': [
            '377'
        ],
        'flag': 'https://flagcdn.com/mc.svg',
        'independent': false
    },
    {
        'name': 'Mongolia',
        'alpha2Code': 'MN',
        'callingCodes': [
            '976'
        ],
        'flag': 'https://flagcdn.com/mn.svg',
        'independent': false
    },
    {
        'name': 'Montenegro',
        'alpha2Code': 'ME',
        'callingCodes': [
            '382'
        ],
        'flag': 'https://flagcdn.com/me.svg',
        'independent': false
    },
    {
        'name': 'Montserrat',
        'alpha2Code': 'MS',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/ms.svg',
        'independent': false
    },
    {
        'name': 'Morocco',
        'alpha2Code': 'MA',
        'callingCodes': [
            '212'
        ],
        'flag': 'https://flagcdn.com/ma.svg',
        'independent': false
    },
    {
        'name': 'Mozambique',
        'alpha2Code': 'MZ',
        'callingCodes': [
            '258'
        ],
        'flag': 'https://flagcdn.com/mz.svg',
        'independent': false
    },
    {
        'name': 'Myanmar',
        'alpha2Code': 'MM',
        'callingCodes': [
            '95'
        ],
        'flag': 'https://flagcdn.com/mm.svg',
        'independent': false
    },
    {
        'name': 'Namibia',
        'alpha2Code': 'NA',
        'callingCodes': [
            '264'
        ],
        'flag': 'https://flagcdn.com/na.svg',
        'independent': false
    },
    {
        'name': 'Nauru',
        'alpha2Code': 'NR',
        'callingCodes': [
            '674'
        ],
        'flag': 'https://flagcdn.com/nr.svg',
        'independent': false
    },
    {
        'name': 'Nepal',
        'alpha2Code': 'NP',
        'callingCodes': [
            '977'
        ],
        'flag': 'https://flagcdn.com/np.svg',
        'independent': false
    },
    {
        'name': 'Netherlands',
        'alpha2Code': 'NL',
        'callingCodes': [
            '31'
        ],
        'flag': 'https://flagcdn.com/nl.svg',
        'independent': false
    },
    {
        'name': 'New Caledonia',
        'alpha2Code': 'NC',
        'callingCodes': [
            '687'
        ],
        'flag': 'https://flagcdn.com/nc.svg',
        'independent': false
    },
    {
        'name': 'New Zealand',
        'alpha2Code': 'NZ',
        'callingCodes': [
            '64'
        ],
        'flag': 'https://flagcdn.com/nz.svg',
        'independent': false
    },
    {
        'name': 'Nicaragua',
        'alpha2Code': 'NI',
        'callingCodes': [
            '505'
        ],
        'flag': 'https://flagcdn.com/ni.svg',
        'independent': false
    },
    {
        'name': 'Niger',
        'alpha2Code': 'NE',
        'callingCodes': [
            '227'
        ],
        'flag': 'https://flagcdn.com/ne.svg',
        'independent': false
    },
    {
        'name': 'Nigeria',
        'alpha2Code': 'NG',
        'callingCodes': [
            '234'
        ],
        'flag': 'https://flagcdn.com/ng.svg',
        'independent': false
    },
    {
        'name': 'Niue',
        'alpha2Code': 'NU',
        'callingCodes': [
            '683'
        ],
        'flag': 'https://flagcdn.com/nu.svg',
        'independent': false
    },
    {
        'name': 'Norfolk Island',
        'alpha2Code': 'NF',
        'callingCodes': [
            '672'
        ],
        'flag': 'https://flagcdn.com/nf.svg',
        'independent': false
    },
    {
        'name': 'Korea (Democratic People\'s Republic of)',
        'alpha2Code': 'KP',
        'callingCodes': [
            '850'
        ],
        'flag': 'https://flagcdn.com/kp.svg',
        'independent': false
    },
    {
        'name': 'Northern Mariana Islands',
        'alpha2Code': 'MP',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/mp.svg',
        'independent': false
    },
    {
        'name': 'Norway',
        'alpha2Code': 'NO',
        'callingCodes': [
            '47'
        ],
        'flag': 'https://flagcdn.com/no.svg',
        'independent': false
    },
    {
        'name': 'Oman',
        'alpha2Code': 'OM',
        'callingCodes': [
            '968'
        ],
        'flag': 'https://flagcdn.com/om.svg',
        'independent': false
    },
    {
        'name': 'Pakistan',
        'alpha2Code': 'PK',
        'callingCodes': [
            '92'
        ],
        'flag': 'https://flagcdn.com/pk.svg',
        'independent': false
    },
    {
        'name': 'Palau',
        'alpha2Code': 'PW',
        'callingCodes': [
            '680'
        ],
        'flag': 'https://flagcdn.com/pw.svg',
        'independent': false
    },
    {
        'name': 'Palestine, State of',
        'alpha2Code': 'PS',
        'callingCodes': [
            '970'
        ],
        'flag': 'https://flagcdn.com/ps.svg',
        'independent': false
    },
    {
        'name': 'Panama',
        'alpha2Code': 'PA',
        'callingCodes': [
            '507'
        ],
        'flag': 'https://flagcdn.com/pa.svg',
        'independent': false
    },
    {
        'name': 'Papua New Guinea',
        'alpha2Code': 'PG',
        'callingCodes': [
            '675'
        ],
        'flag': 'https://flagcdn.com/pg.svg',
        'independent': false
    },
    {
        'name': 'Paraguay',
        'alpha2Code': 'PY',
        'callingCodes': [
            '595'
        ],
        'flag': 'https://flagcdn.com/py.svg',
        'independent': false
    },
    {
        'name': 'Peru',
        'alpha2Code': 'PE',
        'callingCodes': [
            '51'
        ],
        'flag': 'https://flagcdn.com/pe.svg',
        'independent': false
    },
    {
        'name': 'Philippines',
        'alpha2Code': 'PH',
        'callingCodes': [
            '63'
        ],
        'flag': 'https://flagcdn.com/ph.svg',
        'independent': false
    },
    {
        'name': 'Pitcairn',
        'alpha2Code': 'PN',
        'callingCodes': [
            '64'
        ],
        'flag': 'https://flagcdn.com/pn.svg',
        'independent': false
    },
    {
        'name': 'Poland',
        'alpha2Code': 'PL',
        'callingCodes': [
            '48'
        ],
        'flag': 'https://flagcdn.com/pl.svg',
        'independent': false
    },
    {
        'name': 'Portugal',
        'alpha2Code': 'PT',
        'callingCodes': [
            '351'
        ],
        'flag': 'https://flagcdn.com/pt.svg',
        'independent': false
    },
    {
        'name': 'Puerto Rico',
        'alpha2Code': 'PR',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/pr.svg',
        'independent': false
    },
    {
        'name': 'Qatar',
        'alpha2Code': 'QA',
        'callingCodes': [
            '974'
        ],
        'flag': 'https://flagcdn.com/qa.svg',
        'independent': false
    },
    {
        'name': 'Republic of Kosovo',
        'alpha2Code': 'XK',
        'callingCodes': [
            '383'
        ],
        'flag': 'https://flagcdn.com/xk.svg',
        'independent': false
    },
    {
        'name': 'Réunion',
        'alpha2Code': 'RE',
        'callingCodes': [
            '262'
        ],
        'flag': 'https://flagcdn.com/re.svg',
        'independent': false
    },
    {
        'name': 'Romania',
        'alpha2Code': 'RO',
        'callingCodes': [
            '40'
        ],
        'flag': 'https://flagcdn.com/ro.svg',
        'independent': false
    },
    {
        'name': 'Russian Federation',
        'alpha2Code': 'RU',
        'callingCodes': [
            '7'
        ],
        'flag': 'https://flagcdn.com/ru.svg',
        'independent': false
    },
    {
        'name': 'Rwanda',
        'alpha2Code': 'RW',
        'callingCodes': [
            '250'
        ],
        'flag': 'https://flagcdn.com/rw.svg',
        'independent': false
    },
    {
        'name': 'Saint Barthélemy',
        'alpha2Code': 'BL',
        'callingCodes': [
            '590'
        ],
        'flag': 'https://flagcdn.com/bl.svg',
        'independent': false
    },
    {
        'name': 'Saint Helena, Ascension and Tristan da Cunha',
        'alpha2Code': 'SH',
        'callingCodes': [
            '290'
        ],
        'flag': 'https://flagcdn.com/sh.svg',
        'independent': false
    },
    {
        'name': 'Saint Kitts and Nevis',
        'alpha2Code': 'KN',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/kn.svg',
        'independent': false
    },
    {
        'name': 'Saint Lucia',
        'alpha2Code': 'LC',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/lc.svg',
        'independent': false
    },
    {
        'name': 'Saint Martin (French part)',
        'alpha2Code': 'MF',
        'callingCodes': [
            '590'
        ],
        'flag': 'https://flagcdn.com/mf.svg',
        'independent': false
    },
    {
        'name': 'Saint Pierre and Miquelon',
        'alpha2Code': 'PM',
        'callingCodes': [
            '508'
        ],
        'flag': 'https://flagcdn.com/pm.svg',
        'independent': false
    },
    {
        'name': 'Saint Vincent and the Grenadines',
        'alpha2Code': 'VC',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/vc.svg',
        'independent': false
    },
    {
        'name': 'Samoa',
        'alpha2Code': 'WS',
        'callingCodes': [
            '685'
        ],
        'flag': 'https://flagcdn.com/ws.svg',
        'independent': false
    },
    {
        'name': 'San Marino',
        'alpha2Code': 'SM',
        'callingCodes': [
            '378'
        ],
        'flag': 'https://flagcdn.com/sm.svg',
        'independent': false
    },
    {
        'name': 'Sao Tome and Principe',
        'alpha2Code': 'ST',
        'callingCodes': [
            '239'
        ],
        'flag': 'https://flagcdn.com/st.svg',
        'independent': false
    },
    {
        'name': 'Saudi Arabia',
        'alpha2Code': 'SA',
        'callingCodes': [
            '966'
        ],
        'flag': 'https://flagcdn.com/sa.svg',
        'independent': false
    },
    {
        'name': 'Senegal',
        'alpha2Code': 'SN',
        'callingCodes': [
            '221'
        ],
        'flag': 'https://flagcdn.com/sn.svg',
        'independent': false
    },
    {
        'name': 'Serbia',
        'alpha2Code': 'RS',
        'callingCodes': [
            '381'
        ],
        'flag': 'https://flagcdn.com/rs.svg',
        'independent': false
    },
    {
        'name': 'Seychelles',
        'alpha2Code': 'SC',
        'callingCodes': [
            '248'
        ],
        'flag': 'https://flagcdn.com/sc.svg',
        'independent': false
    },
    {
        'name': 'Sierra Leone',
        'alpha2Code': 'SL',
        'callingCodes': [
            '232'
        ],
        'flag': 'https://flagcdn.com/sl.svg',
        'independent': false
    },
    {
        'name': 'Singapore',
        'alpha2Code': 'SG',
        'callingCodes': [
            '65'
        ],
        'flag': 'https://flagcdn.com/sg.svg',
        'independent': false
    },
    {
        'name': 'Sint Maarten (Dutch part)',
        'alpha2Code': 'SX',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/sx.svg',
        'independent': false
    },
    {
        'name': 'Slovakia',
        'alpha2Code': 'SK',
        'callingCodes': [
            '421'
        ],
        'flag': 'https://flagcdn.com/sk.svg',
        'independent': false
    },
    {
        'name': 'Slovenia',
        'alpha2Code': 'SI',
        'callingCodes': [
            '386'
        ],
        'flag': 'https://flagcdn.com/si.svg',
        'independent': false
    },
    {
        'name': 'Solomon Islands',
        'alpha2Code': 'SB',
        'callingCodes': [
            '677'
        ],
        'flag': 'https://flagcdn.com/sb.svg',
        'independent': false
    },
    {
        'name': 'Somalia',
        'alpha2Code': 'SO',
        'callingCodes': [
            '252'
        ],
        'flag': 'https://flagcdn.com/so.svg',
        'independent': false
    },
    {
        'name': 'South Africa',
        'alpha2Code': 'ZA',
        'callingCodes': [
            '27'
        ],
        'flag': 'https://flagcdn.com/za.svg',
        'independent': false
    },
    {
        'name': 'South Georgia and the South Sandwich Islands',
        'alpha2Code': 'GS',
        'callingCodes': [
            '500'
        ],
        'flag': 'https://flagcdn.com/gs.svg',
        'independent': false
    },
    {
        'name': 'Korea (Republic of)',
        'alpha2Code': 'KR',
        'callingCodes': [
            '82'
        ],
        'flag': 'https://flagcdn.com/kr.svg',
        'independent': false
    },
    {
        'name': 'Spain',
        'alpha2Code': 'ES',
        'callingCodes': [
            '34'
        ],
        'flag': 'https://flagcdn.com/es.svg',
        'independent': false
    },
    {
        'name': 'Sri Lanka',
        'alpha2Code': 'LK',
        'callingCodes': [
            '94'
        ],
        'flag': 'https://flagcdn.com/lk.svg',
        'independent': false
    },
    {
        'name': 'Sudan',
        'alpha2Code': 'SD',
        'callingCodes': [
            '249'
        ],
        'flag': 'https://flagcdn.com/sd.svg',
        'independent': false
    },
    {
        'name': 'South Sudan',
        'alpha2Code': 'SS',
        'callingCodes': [
            '211'
        ],
        'flag': 'https://flagcdn.com/ss.svg',
        'independent': false
    },
    {
        'name': 'Suriname',
        'alpha2Code': 'SR',
        'callingCodes': [
            '597'
        ],
        'flag': 'https://flagcdn.com/sr.svg',
        'independent': false
    },
    {
        'name': 'Svalbard and Jan Mayen',
        'alpha2Code': 'SJ',
        'callingCodes': [
            '47'
        ],
        'flag': 'https://flagcdn.com/sj.svg',
        'independent': false
    },
    {
        'name': 'Swaziland',
        'alpha2Code': 'SZ',
        'callingCodes': [
            '268'
        ],
        'flag': 'https://flagcdn.com/sz.svg',
        'independent': false
    },
    {
        'name': 'Sweden',
        'alpha2Code': 'SE',
        'callingCodes': [
            '46'
        ],
        'flag': 'https://flagcdn.com/se.svg',
        'independent': false
    },
    {
        'name': 'Switzerland',
        'alpha2Code': 'CH',
        'callingCodes': [
            '41'
        ],
        'flag': 'https://flagcdn.com/ch.svg',
        'independent': false
    },
    {
        'name': 'Syrian Arab Republic',
        'alpha2Code': 'SY',
        'callingCodes': [
            '963'
        ],
        'flag': 'https://flagcdn.com/sy.svg',
        'independent': false
    },
    {
        'name': 'Taiwan',
        'alpha2Code': 'TW',
        'callingCodes': [
            '886'
        ],
        'flag': 'https://flagcdn.com/tw.svg',
        'independent': false
    },
    {
        'name': 'Tajikistan',
        'alpha2Code': 'TJ',
        'callingCodes': [
            '992'
        ],
        'flag': 'https://flagcdn.com/tj.svg',
        'independent': false
    },
    {
        'name': 'Tanzania, United Republic of',
        'alpha2Code': 'TZ',
        'callingCodes': [
            '255'
        ],
        'flag': 'https://flagcdn.com/tz.svg',
        'independent': false
    },
    {
        'name': 'Thailand',
        'alpha2Code': 'TH',
        'callingCodes': [
            '66'
        ],
        'flag': 'https://flagcdn.com/th.svg',
        'independent': false
    },
    {
        'name': 'Timor-Leste',
        'alpha2Code': 'TL',
        'callingCodes': [
            '670'
        ],
        'flag': 'https://flagcdn.com/tl.svg',
        'independent': false
    },
    {
        'name': 'Togo',
        'alpha2Code': 'TG',
        'callingCodes': [
            '228'
        ],
        'flag': 'https://flagcdn.com/tg.svg',
        'independent': false
    },
    {
        'name': 'Tokelau',
        'alpha2Code': 'TK',
        'callingCodes': [
            '690'
        ],
        'flag': 'https://flagcdn.com/tk.svg',
        'independent': false
    },
    {
        'name': 'Tonga',
        'alpha2Code': 'TO',
        'callingCodes': [
            '676'
        ],
        'flag': 'https://flagcdn.com/to.svg',
        'independent': false
    },
    {
        'name': 'Trinidad and Tobago',
        'alpha2Code': 'TT',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/tt.svg',
        'independent': false
    },
    {
        'name': 'Tunisia',
        'alpha2Code': 'TN',
        'callingCodes': [
            '216'
        ],
        'flag': 'https://flagcdn.com/tn.svg',
        'independent': false
    },
    {
        'name': 'Turkey',
        'alpha2Code': 'TR',
        'callingCodes': [
            '90'
        ],
        'flag': 'https://flagcdn.com/tr.svg',
        'independent': false
    },
    {
        'name': 'Turkmenistan',
        'alpha2Code': 'TM',
        'callingCodes': [
            '993'
        ],
        'flag': 'https://flagcdn.com/tm.svg',
        'independent': false
    },
    {
        'name': 'Turks and Caicos Islands',
        'alpha2Code': 'TC',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/tc.svg',
        'independent': false
    },
    {
        'name': 'Tuvalu',
        'alpha2Code': 'TV',
        'callingCodes': [
            '688'
        ],
        'flag': 'https://flagcdn.com/tv.svg',
        'independent': false
    },
    {
        'name': 'Uganda',
        'alpha2Code': 'UG',
        'callingCodes': [
            '256'
        ],
        'flag': 'https://flagcdn.com/ug.svg',
        'independent': false
    },
    {
        'name': 'Ukraine',
        'alpha2Code': 'UA',
        'callingCodes': [
            '380'
        ],
        'flag': 'https://flagcdn.com/ua.svg',
        'independent': false
    },
    {
        'name': 'United Arab Emirates',
        'alpha2Code': 'AE',
        'callingCodes': [
            '971'
        ],
        'flag': 'https://flagcdn.com/ae.svg',
        'independent': false
    },
    {
        'name': 'United Kingdom of Great Britain and Northern Ireland',
        'alpha2Code': 'GB',
        'callingCodes': [
            '44'
        ],
        'flag': 'https://flagcdn.com/gb.svg',
        'independent': false
    },
    {
        'name': 'United States of America',
        'alpha2Code': 'US',
        'callingCodes': [
            '1'
        ],
        'flag': 'https://flagcdn.com/us.svg',
        'independent': false
    },
    {
        'name': 'Uruguay',
        'alpha2Code': 'UY',
        'callingCodes': [
            '598'
        ],
        'flag': 'https://flagcdn.com/uy.svg',
        'independent': false
    },
    {
        'name': 'Uzbekistan',
        'alpha2Code': 'UZ',
        'callingCodes': [
            '998'
        ],
        'flag': 'https://flagcdn.com/uz.svg',
        'independent': false
    },
    {
        'name': 'Vanuatu',
        'alpha2Code': 'VU',
        'callingCodes': [
            '678'
        ],
        'flag': 'https://flagcdn.com/vu.svg',
        'independent': false
    },
    {
        'name': 'Venezuela (Bolivarian Republic of)',
        'alpha2Code': 'VE',
        'callingCodes': [
            '58'
        ],
        'flag': 'https://flagcdn.com/ve.svg',
        'independent': false
    },
    {
        'name': 'Vietnam',
        'alpha2Code': 'VN',
        'callingCodes': [
            '84'
        ],
        'flag': 'https://flagcdn.com/vn.svg',
        'independent': false
    },
    {
        'name': 'Wallis and Futuna',
        'alpha2Code': 'WF',
        'callingCodes': [
            '681'
        ],
        'flag': 'https://flagcdn.com/wf.svg',
        'independent': false
    },
    {
        'name': 'Western Sahara',
        'alpha2Code': 'EH',
        'callingCodes': [
            '212'
        ],
        'flag': 'https://flagcdn.com/eh.svg',
        'independent': false
    },
    {
        'name': 'Yemen',
        'alpha2Code': 'YE',
        'callingCodes': [
            '967'
        ],
        'flag': 'https://flagcdn.com/ye.svg',
        'independent': false
    },
    {
        'name': 'Zambia',
        'alpha2Code': 'ZM',
        'callingCodes': [
            '260'
        ],
        'flag': 'https://flagcdn.com/zm.svg',
        'independent': false
    },
    {
        'name': 'Zimbabwe',
        'alpha2Code': 'ZW',
        'callingCodes': [
            '263'
        ],
        'flag': 'https://flagcdn.com/zw.svg',
        'independent': false
    }
];

const API_COUNTRIES = ENV.API.COUNTRIES;

export const getAll = async (): Promise<RestCountryResponse[]> => {
  
  const initialResponse = fallbackResponse;

  // PRIMERO BUSCA DEL ARCHIVO Y LUEGO HACE LA PETICION - INVERTIDO LA LOGICA PARA NO HACER PETICIONES A TODO MOMENTO
  if (initialResponse.length > 0) {
    return initialResponse;
  }

  return countries
  .get(`${API_COUNTRIES}all`, {
    params: { fields: 'name,alpha2Code,flag,callingCodes' },
    timeout: 5000,
  })
  .then((response: { data: RestCountryResponse[] }) => response.data)
  .catch(() => fallbackResponse);
};

export const getFlagByAlpha2 = async (alpha: string) => {
  try {
    const url = `${API_COUNTRIES}alpha/${alpha}`;
    const response = await countries.get(url, {
      params: { fields: 'flag' },
      timeout: 5000,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
